import { AdminComponent } from '~/components/admin-component/admin-component';

export const CommitteeGroups = () => (
  <AdminComponent
    componentName="CommitteeGroups"
    title="Committee Groups"
  />
);
